import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledOutletAdditionalDetails = styled.div`
  // .footer-width {
  //   max-width: ${toRem(243)};
  // }

  .social-icons {
    font-size: ${toRem(20)};
  }

  @media ${baseVariables.mediaQuery.md} {
    max-width: auto;
  }

  .additional-details {
    &__link,
    &__section-label {
      font-weight: 700;
    }
    &__link {
      text-decoration: underline;
      text-transform: capitalize;
    }
    &__non-link {
      cursor: default;
      text-align: left;
      background: none;
      padding-left: 0px;
    }
    span:first-child {
      font-size: ${toRem(16)};
    }
  }

  .social-icons-container {
    display: grid;
    grid-template-columns: auto auto auto auto auto;
    column-gap: ${toRem(20)};
    width: fit-content;
    row-gap: ${toRem(14)};
  }

  .payment-image-container {
    row-gap: ${toRem(8)};
    column-gap: ${toRem(8)};
  }

  .payment-image {
    max-width: ${toRem(48)};
    max-height: ${toRem(32)};
    aspect-ratio: 3/2;
  }

  @media ${baseVariables.mediaQuery.xl} {
    .row {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      column-gap: ${toRem(24)};
      margin-left: 0;
      margin-right: 0;
    }

    .row > div {
      max-width: 100%;
      width: 100%;
      margin: 0;
    }
  }
`;
